import { useState, useEffect } from 'react';
import { fetchOtorganteParams } from '../api';
import { applyTheme } from '../theme';
import type { ParametroOtorgante } from '../types';

interface UseOtorganteResult {
  params:  ParametroOtorgante[];
  loading: boolean;
  error:   string | null;
}

/**
 * Carga los parámetros de personalización del otorgante y aplica su tema CSS.
 * Si no se proporciona apikey, retorna estado vacío sin hacer petición.
 */
export function useOtorgante(apikey: string): UseOtorganteResult {
  const [params,  setParams]  = useState<ParametroOtorgante[]>([]);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState<string | null>(null);

  useEffect(() => {
    if (!apikey.trim()) return;

    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchOtorganteParams(apikey)
      .then((data) => {
        if (cancelled) return;
        setParams(data);
        applyTheme(data);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        const msg = err instanceof Error ? err.message : String(err);
        console.warn('[useOtorgante]', msg);
        setError(msg);
      })
      .finally(() => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; };
  }, [apikey]);

  return { params, loading, error };
}
